import { useState } from "react";
import { WiHumidity, WiStrongWind, WiSunrise, WiSunset } from "react-icons/wi";
import "./App.css";

function App() {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getWeather = async () => {
    if (!city) {
      setError("Please enter a city name");
      return;
    }

    setLoading(true);
    setError("");
    setWeather(null);

    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=d03067a0d4b391088e7fdf23d44d544a&units=metric`
      );

      const data = await response.json();

      if (data.cod !== 200) {
        setError(data.message);
        setLoading(false);
        return;
      }

      setWeather(data);
    } catch {
      setError("Something went wrong. Try again.");
    }

    setLoading(false);
  };

  const formatTime = (time) => {
    return new Date(time * 1000).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getBackground = () => {
    if (!weather || !weather.weather) return "default";

    const condition = weather.weather[0].main;

    if (condition === "Clear") return "clear";
    if (condition === "Clouds") return "clouds";
    if (condition === "Rain") return "rain";

    return "default";
  };

  return (
    <div className={`app ${getBackground()}`}>
      <div className="card">
        <h1 className="title">Weather</h1>

        <input
          type="text"
          placeholder="Enter city"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />

        <button onClick={getWeather} disabled={loading}>
          {loading ? "Loading..." : "Get Weather"}
        </button>

        {loading && <p className="loading">Checking the sky… ☁️</p>}
        {error && <p className="loading">{error}</p>}

        {weather && weather.main && !loading && (
          <div className="result">
            <h2>{weather.name}</h2>

            <img
              src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}@2x.png`}
              alt="weather"
              className="weather-icon"
            />

            <p className="temp">{weather.main.temp}°C</p>
            <p className="desc">{weather.weather[0].description}</p>

            <div className="extra">
              <div>
                <WiHumidity size={30} />
                <span>{weather.main.humidity}%</span>
              </div>

              <div>
                <WiStrongWind size={30} />
                <span>{weather.wind.speed} m/s</span>
              </div>

              <div>
                <WiSunrise size={30} />
                <span>{formatTime(weather.sys.sunrise)}</span>
              </div>

              <div>
                <WiSunset size={30} />
                <span>{formatTime(weather.sys.sunset)}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
